import React from "react";
import {
  FaLightbulb,
  FaProjectDiagram,
  FaPalette,
  FaFileContract,
  FaCube,
  FaRocket,
} from "react-icons/fa";

function Conceptualization() {
  return (
    <>
      <div className="team-single-area default-padding">
        <div className="container">
          <div className="team-single-items">
            <div className="row">
              <div className="col-lg-5 left-info">
                <div className="thumb fade-up-anim">
                  <img
                    src="https://validthemes.net/site-template/robok/assets/img/team/5.jpg"
                    alt="Thumb"
                  />
                </div>
              </div>

              <div className="col-lg-7 right-info pl-30 pl-md-15 pl-xs-15">
                <div className="container">
                  <div className=" col-lg-12">
                    <div className="site-heading">
                      <h4 className="sub-title">Our Services</h4>
                      <h2 className="title split-text-right split-text-in-right split-lines">
                        NFT Development Services
                      </h2>
                      <p>
                        The NFT development process involves several key stages
                        that transform your concept into a fully functional
                        non-fungible token, ready for deployment on the
                        blockchain. Here's an overview of the steps involved:
                      </p>
                    </div>
                  </div>
                </div>

                <div className="">
                  <div className="">
                    <div className="container">
                      <div className="services-style-four-items">
                        <div className="services-style-four-item">
                          <div className="icon">
                            <FaLightbulb size={35} />
                          </div>
                          <h4>Conceptualization & Consultation</h4>
                          <p>
                            The process begins with understanding your vision
                            and objectives for the NFT project. Whether you’re
                            creating digital art, tokenizing real-world assets,
                            or building an NFT-based platform, we work with you
                            to refine the idea and outline the technical
                            requirements.
                          </p>
                        </div>

                        <div className="services-style-four-item">
                          <div className="icon">
                            <FaProjectDiagram size={35} />
                          </div>
                          <h4>Blockchain Selection</h4>
                          <p>
                            Based on your project’s needs, we help you select
                            the most suitable blockchain network (e.g.,
                            Ethereum, Binance Smart Chain, Solana, Polygon).
                            This decision depends on factors like transaction
                            speed, cost, scalability, and the target audience.
                          </p>
                        </div>

                        <div className="services-style-four-item">
                          <div className="icon">
                            <FaPalette size={35} />
                          </div>
                          <h4>NFT Design & Metadata Creation</h4>
                          <p>
                            Our team collaborates with you to design custom
                            NFTs, focusing on the visual elements, asset
                            attributes, and metadata (information that defines
                            the NFT’s unique properties, such as its name,
                            description, and traits). This ensures your NFTs are
                            one-of-a-kind and recognizable.
                          </p>
                        </div>

                        <div className="services-style-four-item">
                          <div className="icon">
                            <FaFileContract size={35} />
                          </div>
                          <h4>Smart Contract Development</h4>
                          <p>
                            We develop secure, tamper-proof smart contracts that
                            handle the minting, ownership transfers, and other
                            functionalities of your NFTs. We ensure compliance
                            with leading token standards like ERC-721, ERC-1155,
                            or other relevant protocols.
                          </p>
                        </div>

                        <div className="services-style-four-item">
                          <div className="icon">
                            <FaCube size={35} />
                          </div>
                          <h4>NFT Minting</h4>
                          <p>
                            Once the design and smart contract are ready, the
                            NFTs are minted (created) on the chosen blockchain.
                            Each minted NFT is linked to its corresponding
                            metadata and becomes a verifiable digital asset that
                            can be traded, sold, or transferred.
                          </p>
                        </div>

                        <div className="services-style-four-item">
                          <div className="icon">
                            <FaRocket size={35} />
                          </div>
                          <h4>Launch & Support</h4>
                          <p>
                            After successful testing, your NFTs are deployed to
                            the blockchain and made available to the public. We
                            provide post-launch support to ensure smooth
                            operation and address any issues that arise.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Conceptualization;
